<template>
    <div class="indexBox">
        <!-- 数智实验室 -->
        <div class="labSection">
            <iframe :src="labUrl" frameborder="0" scrolling="auto"></iframe>
        </div>
        <!-- 业务范围 -->
       <business></business>
       <!-- 媒体中心 -->
       <media v-if="!isMobile"></media>
       <media-wx v-if="isMobile"></media-wx>
       <!-- 瑞和在中国 -->
       <nationalMap></nationalMap>
    </div>
</template>

<script>
    import business from './components/business'
    import media from './components/media'
    import mediaWx from './components/media-wx'
    import nationalMap from './components/national-map'
	export default {
		name:'Index',
        components:{business,media,mediaWx,nationalMap},
        data() {
            return {
                labUrl: window.location.origin + '/szsys/#/index?layout=compact',
            }
        },
        mounted() {
            // banner已移除，无需计算高度
        },
        methods: {
           
        },
	}
</script>
<style scoped lang="less">
    .indexBox {
        background: #F8F8F8;
    }

    .labSection {
        width: 100%;
        overflow: hidden;
    }
    .labSection iframe {
        width: 100%;
        height: 730px;
        border: none;
    }
</style>
